import { api } from './api';

export const appConfigApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAppConfigForSite: builder.query({
      query: () => {
        return {
          url: 'getAppConfigForSite',
          method: 'get',
        };
      },
    }),
    getAppConfig: builder.mutation({
      query: () => {
        return {
          url: 'getAppConfig',
          method: 'get',
        };
      },
    }),
    verifyMailCredentials: builder.mutation({
      query: (credentials) => ({
        url: 'verifyMailCredentials',
        method: 'POST',
        body: credentials,
      }),
    }),
    saveAppConfig: builder.mutation({
      query: (config) => ({
        url: 'saveAppConfig',
        method: 'POST',
        body: config,
      }),
    }),
  }),
});

export const {
  useGetAppConfigForSiteQuery,
  useGetAppConfigMutation,
  useSaveAppConfigMutation,
  useVerifyMailCredentialsMutation,
} = appConfigApi;

export const {
  endpoints: {
    getAppConfig,
    saveAppConfig,
  },
} = appConfigApi;
